import checkTabButtonTargetted from './functions/checkTabButtonTargetted';
import selectTab from './functions/selectTab';
import selectNextTab from './functions/selectNextTab';
import selectPreviousTab from './functions/selectPreviousTab';

const tabSelection = () => {
  window.addEventListener('DOMContentLoaded', () => {
    const listOfTabBlocks = document.querySelectorAll('.wp-block-bigbite-tabs');

    listOfTabBlocks.forEach((tabsBlock) => {
      const tabsContainer = tabsBlock.querySelector('.tabsContainer');
      let listOfTabs = tabsBlock.querySelectorAll('.tab');
      let listOfTabPanels = tabsBlock.querySelectorAll('.tabPanel');

      // This event listener selects, shows and highlights the tab that the user clicked on.
      tabsContainer.addEventListener('click', (e) => {
        if (!checkTabButtonTargetted(e)) {
          return;
        }

        listOfTabs = tabsBlock.querySelectorAll('.tab');
        listOfTabPanels = tabsBlock.querySelectorAll('.tabPanel');

        const targettedTab = e.target.closest('.tab');
        selectTab(targettedTab, listOfTabs, listOfTabPanels);
      });

      tabsContainer.addEventListener('keydown', (e) => {
        if (!checkTabButtonTargetted(e)) {
          return;
        }

        const targettedTab = e.target.closest('.tab');

        switch (e.key) {
          case 'ArrowLeft':
            selectPreviousTab(targettedTab, listOfTabs, listOfTabPanels);
            break;
          case 'ArrowRight':
            selectNextTab(targettedTab, listOfTabs, listOfTabPanels);
            break;
          default:
        }
      });
    });

    const urlHash = window.location.hash.replace('#', '');

    listOfTabBlocks.forEach((tabsBlock) => {
      const listOfTabs = tabsBlock.querySelectorAll('.tab');
      const listOfTabPanels = tabsBlock.querySelectorAll('.tabPanel');

      listOfTabs.forEach((tab) => {
        const htmlId = tab.getAttribute('id');

        if (urlHash === htmlId) {
          selectTab(tab, listOfTabs, listOfTabPanels);
        }
      });
    });
  });
};

export default tabSelection;
